import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class CursorType extends AStringEnum
{
    // public static INHERIT = new AString('inherit');
    // public static AUTO = new AString('auto');
    public static DEFAULT = new AString('default');
    public static NONE = new AString('none');
    public static CONTEXT_MENU = new AString('context-menu');
    public static HELP = new AString('help');
    public static POINTER = new AString('pointer');
    public static PROGRESS = new AString('progress');
    public static WAIT = new AString('wait');
    public static CELL = new AString('cell');
    public static CROSSHAIR = new AString('crosshair');
    public static TEXT = new AString('text');
    public static VERTICAL_TEXT = new AString('vertical-text');
    public static ALIAS = new AString('alias');
    public static COPY = new AString('copy');
    public static MOVE = new AString('move');
    public static NO_DROP = new AString('no-drop');
    public static NOT_ALLOWED = new AString('not-allowed');
    public static E_RESIZE = new AString('e-resize');
    public static N_RESIZE = new AString('n-resize');
    public static NE_RESIZE = new AString('ne-resize');
    public static NW_RESIZE = new AString('nw-resize');
    public static S_RESIZE = new AString('s-resize');
    public static SE_RESIZE = new AString('se-resize');
    public static SW_RESIZE = new AString('sw-resize');
    public static W_RESIZE = new AString('w-resize');
    public static EW_RESIZE = new AString('ew-resize');
    public static NS_RESIZE = new AString('ns-resize');
    public static NESW_RESIZE = new AString('nesw-resize');
    public static NWSE_RESIZE = new AString('nwse-resize');
    public static COL_RESIZE = new AString('col-resize');
    public static ROW_RESIZE = new AString('row-resize');
    public static ALL_SCROLL = new AString('all-scroll');
    public static ZOOM_IN = new AString('zoom-in');
    public static ZOOM_OUT = new AString('zoom-out');
    public static GRAB = new AString('grab');
    public static GRABBING = new AString('grabbing');
    public static CUSTOM = new AString('custom');

    public static availableValues:Array<AString> = [
        // CursorType.INHERIT,
        // CursorType.AUTO,
        CursorType.DEFAULT,
        CursorType.POINTER,
        CursorType.TEXT,
        CursorType.NOT_ALLOWED,
        CursorType.WAIT,
        CursorType.CUSTOM,

        // ---------------------

        CursorType.ALIAS,
        CursorType.ALL_SCROLL,
        CursorType.CELL,
        // CursorType.CONTEXT_MENU,
        CursorType.COPY,
        CursorType.CROSSHAIR,
        CursorType.GRAB,
        CursorType.GRABBING,
        CursorType.HELP,
        CursorType.MOVE,
        // CursorType.NO_DROP,
        CursorType.NONE,
        CursorType.PROGRESS,
        CursorType.VERTICAL_TEXT,
        CursorType.ZOOM_IN,
        CursorType.ZOOM_OUT,
        // CursorType.E_RESIZE,
        // CursorType.N_RESIZE,
        // CursorType.NE_RESIZE,
        // CursorType.NW_RESIZE,
        // CursorType.S_RESIZE,
        // CursorType.SE_RESIZE,
        // CursorType.SW_RESIZE,
        // CursorType.W_RESIZE,
        // CursorType.EW_RESIZE,
        // CursorType.NS_RESIZE,
        // CursorType.NESW_RESIZE,
        // CursorType.NWSE_RESIZE,
        // CursorType.COL_RESIZE,
        // CursorType.ROW_RESIZE,
    ];

    public static topItemsForSelect:Array<AString> = [
        CursorType.DEFAULT,
        CursorType.POINTER,
        CursorType.TEXT,
        CursorType.NOT_ALLOWED,
        CursorType.WAIT,
        CursorType.CUSTOM,
    ];

    public static bottomItemsForSelect:Array<AString> = [
        CursorType.ALIAS,
        CursorType.ALL_SCROLL,
        CursorType.CELL,
        // CursorType.CONTEXT_MENU,
        CursorType.COPY,
        CursorType.CROSSHAIR,
        CursorType.GRAB,
        CursorType.GRABBING,
        CursorType.HELP,
        CursorType.MOVE,
        // CursorType.NO_DROP,
        CursorType.NONE,
        CursorType.PROGRESS,
        CursorType.VERTICAL_TEXT,
        CursorType.ZOOM_IN,
        CursorType.ZOOM_OUT,
    ];

    public constructor(value:AString)
    {
        super(value, CursorType.availableValues);
    }

    public static default():CursorType
    {
        return new CursorType(CursorType.DEFAULT);
    }

    public static custom():CursorType
    {
        return new CursorType(CursorType.CUSTOM);
    }

    public static isCustom(type:CursorType):boolean
    {
        return CursorType.custom().isEqualTo(type);
    }
}
